export default __webpack_public_path__ + "static/media/Icon-upload.3a893897.svg";